export const ackoDriveWidgetReader = {
heading: (blogAdWidget) => blogAdWidget?.attributes?.blogWidgetAdMainHeading,
ctaText: (blogAdWidget) => blogAdWidget?.attributes?.widgetCtaTex,
}
